import {getDiffHunksData} from '../../helpers/hunk-data-helpers'
import type {DiffLine} from '../../types'
import {SimpleUnifiedDiffRow} from './SimpleUnifiedDiffRow'

export function SimpleUnifiedDiffLines({
  diffLines,
  filePath,
  avatarURL,
  userLogin,
  viewerCanApplySuggestion,
  viewerCanComment,
  shouldDisplayComments,
}: {
  diffLines: DiffLine[]
  filePath: string
  avatarURL?: string
  userLogin?: string
  viewerCanApplySuggestion?: boolean
  viewerCanComment?: boolean
  shouldDisplayComments?: boolean
}) {
  // TODO: move this to the store? would need to be updated as context lines were added though.
  const hunksData = getDiffHunksData(diffLines.map(diffLine => diffLine))
  return diffLines.map((diffLine, index) => {
    const key = `unified-diff-row-l:${diffLine.left}-r:${diffLine.right}-b:${diffLine.blobLineNumber}`

    const nextDiffLine = diffLines[index + 1]
    const prevDiffLine = diffLines[index - 1]
    return (
      <SimpleUnifiedDiffRow
        hunksData={hunksData}
        diffLine={diffLine}
        nextDiffLine={nextDiffLine}
        prevDiffLine={prevDiffLine}
        filePath={filePath}
        key={key}
        avatarURL={avatarURL}
        userLogin={userLogin}
        viewerCanApplySuggestion={viewerCanApplySuggestion}
        viewerCanComment={viewerCanComment}
        shouldDisplayComments={shouldDisplayComments}
      />
    )
  })
}

try{ SimpleUnifiedDiffLines.displayName ||= 'SimpleUnifiedDiffLines' } catch {}